import { sanitizeLabelMap } from '../utilities/sanitizeLabelMarkup';

const ADD_LABELS = 'WS_SCRIPTS_ADD_LABELS';

// Drops tag tokens the DOM would reject from every label as it lands, so a
// dealer label like `Total <data-href="/x" >Fees` can't throw
// InvalidCharacterError during React's commit (US2051450).
const sanitizeLabels = () => (next) => (action) => {
	if (!action || action.error || action.payload === undefined) {
		return next(action);
	}

	if (action.type === ADD_LABELS) {
		return next({ ...action, payload: sanitizeLabelMap(action.payload) });
	}

	return next(action);
};

export default [sanitizeLabels];
